var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToccompare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 8.00065C5.33398 8.7079 5.61494 9.38617 6.11503 9.88627C6.61513 10.3864 7.29341 10.6673 8.00065 10.6673C8.7079 10.6673 9.38617 10.3864 9.88627 9.88627C10.3864 9.38617 10.6673 8.7079 10.6673 8.00065C10.6673 7.29341 10.3864 6.61513 9.88627 6.11503C9.38617 5.61494 8.7079 5.33398 8.00065 5.33398C7.29341 5.33398 6.61513 5.61494 6.11503 6.11503C5.61494 6.61513 5.33398 7.29341 5.33398 8.00065Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.334 24.0007C21.334 24.7079 21.6149 25.3862 22.115 25.8863C22.6151 26.3864 23.2934 26.6673 24.0007 26.6673C24.7079 26.6673 25.3862 26.3864 25.8863 25.8863C26.3864 25.3862 26.6673 24.7079 26.6673 24.0007C26.6673 23.2934 26.3864 22.6151 25.8863 22.115C25.3862 21.6149 24.7079 21.334 24.0007 21.334C23.2934 21.334 22.6151 21.6149 22.115 22.115C21.6149 22.6151 21.334 23.2934 21.334 24.0007Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.666 8H21.3327C22.0399 8 22.7182 8.28095 23.2183 8.78105C23.7184 9.28115 23.9993 9.95942 23.9993 10.6667V21.3333",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.666 12L14.666 8L18.666 4",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 24.3333H10.6667C9.95942 24.3333 9.28115 24.0524 8.78105 23.5523C8.28095 23.0522 8 22.3739 8 21.6667V11",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 20L17.334 24L13.334 28",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToccompare);
export default __webpack_public_path__ + "static/media/toccompare.c8d5491394170de1ceb64b33a4fca284.svg";
export { ForwardRef as ReactComponent };